// Session-memory operation metadata only: never retain the body or credentials.
// Survives editor navigation. No automatic retries or persistence in browser storage.
const pending = new Map()

export async function requestSystemAction(request, host, path, body = {}) {
  const bytes = new TextEncoder().encode(JSON.stringify(body))
  const digest = Array.from(new Uint8Array(await crypto.subtle.digest('SHA-256', bytes)), (value) => value.toString(16).padStart(2, '0')).join('')
  bytes.fill(0)
  const scope = `${host}/${path}`
  let operation = pending.get(scope)
  if (operation?.busy) throw new Error('system_action_in_progress')
  if (operation && operation.digest !== digest) throw new Error('retry_original_configuration_before_new_action')
  if (!operation) {
    operation = { digest, key: crypto.randomUUID(), busy: false }
    pending.set(scope, operation)
  }
  operation.busy = true
  try {
    const result = await request(path, { method: 'POST', body, idempotencyKey: operation.key })
    pending.delete(scope)
    return result
  } catch (error) {
    // Timeouts, malformed responses, conflicts and server failures have unknown outcomes.
    // Only a definite request rejection permits a fresh action key.
    if ([400, 401, 403, 404, 405, 422].includes(error?.status) && error?.code !== 'invalid_response') pending.delete(scope)
    throw error
  } finally { operation.busy = false }
}
